import React, { useEffect, useState } from 'react';
import cx from 'classnames';
// components
import { Icons } from '../../components';
const arrowLeftIcon = React.createElement(Icons, { iconName: "ic-ui-arrow-left", size: "20" });
const chevronRightIcon = React.createElement(Icons, { iconName: "ic-ui-chevron-right", size: "20" });
const MenuList = ({ links }) => {
    return (React.createElement("div", { className: "menu-item" },
        React.createElement("div", { className: "primary-nav-container" },
            React.createElement("ul", { className: "menu-list" }, links))));
};
export const MobileNavBar = ({ links, LinkComponent, title = '', icon, userDashboardsMenuKey = 'dashboards', userDashboards = [], subMenuLinkSelected, }) => {
    const [isNavOpen, setIsNavOpen] = useState(false);
    const [isDashboardsMenu, setIsDashboardsMenu] = useState(false);
    const [selectedReportId, setSelectedReportId] = useState('');
    useEffect(() => {
        if (userDashboards.length && subMenuLinkSelected) {
            subMenuLinkSelected(userDashboards[0]);
            setSelectedReportId(userDashboards[0].id);
        }
    }, [userDashboards]);
    const createLinkElements = (linkArray) => {
        const linkElements = [];
        linkArray.forEach(({ key, name, link, icon, isMobile, onClick }) => {
            const onClickBehaviour = event => {
                if (key === userDashboardsMenuKey) {
                    setIsDashboardsMenu(true);
                }
                else if (onClick) {
                    onClick(event);
                }
            };
            if (typeof isMobile !== undefined && isMobile) {
                linkElements.push(React.createElement("li", { key: key },
                    React.createElement(LinkComponent, { to: link, href: link, className: "navbar-link-mobile", onClick: onClickBehaviour },
                        React.createElement("span", { className: "navbar-link-icon" }, icon),
                        React.createElement("span", { className: "navbar-link-content" }, name))));
            }
        });
        return linkElements;
    };
    const SubMenuDashbaordList = ({ userDashboards }) => {
        return (React.createElement("div", { className: "menu-item" },
            React.createElement("div", { className: "intro-link" },
                React.createElement("a", { className: "wdc-type-nav", onClick: () => {
                        setIsDashboardsMenu(false);
                    } },
                    React.createElement("span", { className: "intro-link-icon" }, arrowLeftIcon),
                    "Dashboard")),
            userDashboards.map(report => (React.createElement("div", { key: report.id, className: "nested-menu" },
                React.createElement("a", { className: cx('category-title', {
                        active: selectedReportId === report.id,
                    }), onClick: () => {
                        if (subMenuLinkSelected) {
                            subMenuLinkSelected(report);
                            setSelectedReportId(report.id);
                            setIsNavOpen(false);
                        }
                    } },
                    report.name,
                    React.createElement("span", { className: "category-icon" }, chevronRightIcon)))))));
    };
    return (React.createElement("header", { className: cx('mobile-header') },
        React.createElement("div", { className: "nav-header" },
            React.createElement("div", { className: "heading-wrapper" },
                React.createElement("div", null,
                    React.createElement("span", null,
                        React.createElement("div", { className: "title-wrapper" },
                            icon && title && (React.createElement("div", { className: "logo-title" },
                                React.createElement("div", { className: "nav-logo-placeholder" }, icon),
                                React.createElement("h3", { className: "nav-title" }, title))),
                            !icon && title && (React.createElement("div", { className: "logo-title" },
                                React.createElement("h3", { className: "nav-title no-logo" }, title))),
                            icon && !title && (React.createElement("div", { className: "logo-title" },
                                React.createElement("div", { className: "nav-logo-placeholder" }, icon))))))),
            React.createElement("div", { className: "button-wrapper" },
                React.createElement("a", { className: cx('mobile-nav-toggle', { open: isNavOpen }), onClick: () => {
                        setIsNavOpen(!isNavOpen);
                    } },
                    React.createElement("div", null,
                        React.createElement("span", null),
                        React.createElement("span", null),
                        React.createElement("span", null),
                        React.createElement("span", null))))),
        React.createElement("div", { className: cx('global-nav', 'mobile-nav', { open: isNavOpen }) },
            React.createElement("div", { className: "mobile-nav-content" }, isNavOpen && (React.createElement("div", { className: cx('menu-container', 'slide', {
                    'slide-1': !isDashboardsMenu,
                    'slide-2': isDashboardsMenu,
                }) },
                !isDashboardsMenu && React.createElement(MenuList, { links: createLinkElements(links) }),
                isDashboardsMenu && React.createElement(SubMenuDashbaordList, { userDashboards: userDashboards })))))));
};
//# sourceMappingURL=MobileNavBar.js.map